<template>
  <div class="def-swiper">
    <DefSwiperButtonPrev ref="prev" />
    <Swiper
      v-if="init"
      v-bind="sliderSettings"
      @swiper="$emit('swiper', $event)"
      @slideChange="$emit('slideChange', $event)"
    >
      <slot />
    </Swiper>
    <DefSwiperButtonNext ref="next" />
    <div v-if="timeLine" ref="progress" class="def-swiper-progress"></div>
  </div>
</template>

<script lang="ts" setup>
import { Swiper } from 'swiper/vue';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { Navigation, Pagination } from 'swiper/modules';
import { ref, onMounted, ComponentPublicInstance, nextTick } from 'vue';
import DefSwiperButtonPrev from '@components/Def/DefSwiper/DefSwiperButtonPrev.vue';
import DefSwiperButtonNext from '@components/Def/DefSwiper/DefSwiperButtonNext.vue';

// import 'swiper/css';
// import 'swiper/css/effect-cube';
// import 'swiper/css/pagination';
// import 'swiper/css/navigation';

const init = ref<boolean>(false);

const prev = ref<ComponentPublicInstance<HTMLInputElement>>();
const next = ref<ComponentPublicInstance<HTMLInputElement>>();
const progress = ref<ComponentPublicInstance<HTMLDivElement>>();

const props = defineProps<{ settings?: SwiperOptions; timeLine?: boolean }>();

let sliderSettings: SwiperOptions = {};

// let animationId: number | null = null;
// const progressClasses = '';
const progressSpeed = `${props?.settings?.autoplay?.delay || 5000}ms`;

const move = () => {
  // let width = 1;
  // if (animationId) {
  //   cancelAnimationFrame(animationId);
  // }
  // animationId = requestAnimationFrame(frame);
  // const start = performance.now();
  // const delay = props?.settings?.autoplay?.delay || 5000;
  //
  // function frame() {
  //   if (width >= 100) {
  //     if (animationId) cancelAnimationFrame(animationId);
  //     return;
  //   }
  //
  //   const now = performance.now();
  //   const delta = Math.min((now - start) / delay, 1);
  //
  //   width = delta * 100;
  //
  //   if (progress.value) {
  //     progress.value.style.width = `${width}%`;
  //   }
  //
  //   if (delta < 1) {
  //     animationId = requestAnimationFrame(frame);
  //   }
  // }
};

onMounted(() => {
  sliderSettings = {
    modules: [Navigation, Pagination],
    pagination: {
      clickable: true,
    },
    navigation: {
      prevEl: prev.value?.$el,
      nextEl: next.value?.$el,
    },
    // breakpoints: {
    //     768: {
    //         slidesPerView: 5,
    //         spaceBetween: 8,
    //         slidesPerGroup: 5,
    //     },
    //     992: {
    //         slidesPerView: 6,
    //         spaceBetween: 16,
    //         slidesPerGroup: 6,
    //     },
    // },
    // onSlideChange() {
    //   console.log('changeSlide');
    // },
    ...props.settings,
  };

  if (props.timeLine) {
    nextTick(() => progress.value.classList.add('def-swiper-progress-active'));
    sliderSettings.onSlideChangeTransitionEnd = () => {
      progress.value.classList.add('def-swiper-progress-active');
    };
    sliderSettings.onSlideChangeTransitionStart = () => {
      progress.value.classList.remove('def-swiper-progress-active');
    };
  }

  init.value = true;
});
// onBeforeUnmount(() => {
//   if (animationId) {
//     cancelAnimationFrame(animationId);
//     animationId = null;
//   }
// });
</script>

<style lang="scss" scoped>
.def-swiper {
  position: relative;
  :deep(.swiper-pagination-bullet) {
    background-color: var(--border-colour-primary);
    width: 8px;
    height: 8px;
    margin-left: 0;
    opacity: 0.35;
    margin-bottom: 8px;
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
  :deep(.swiper-pagination-bullet-active) {
    opacity: 1;
  }
  :deep(.swiper-pagination) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    position: static;
    margin-top: 16px;
    margin-bottom: -8px;
  }
  :deep(.def-swiper-button-prev),
  :deep(.def-swiper-button-next) {
    position: absolute;
    top: 50%;
    z-index: 2;
  }
  :deep(.def-swiper-button-prev) {
    left: 0;
    transform: translate(-12px, calc(-50% - 12px));
  }
  :deep(.def-swiper-button-next) {
    right: 0;
    transform: translate(12px, calc(-50% - 12px));
  }
  :deep(.swiper-wrapper) {
    align-items: stretch;
  }
  :deep(.swiper-slide) {
    height: unset;
  }
  :deep(.swiper-button-lock) {
    display: none;
  }
  //  fix styles for ios cube effect don't remove and include official styles.
  :deep(.swiper-cube) {
    overflow: visible;
    .swiper-slide {
      pointer-events: none;
      backface-visibility: hidden;
      z-index: 1;
      visibility: hidden;
      transform-origin: 0 0;
      width: 100%;
      height: 100%;

      //-webkit-perspective: 0;
      //-webkit-backface-visibility: hidden;
      //-webkit-transform: translate3d(0, 0, 0);
      //visibility: visible;
      //backface-visibility: hidden;

      .swiper-slide {
        pointer-events: none;
      }
    }
    &.swiper-rtl .swiper-slide {
      transform-origin: 100% 0;
    }
    .swiper-slide-active {
      &,
      & .swiper-slide-active {
        pointer-events: auto;
      }
    }
    .swiper-slide-active,
    .swiper-slide-next:not(:first-child),
    .swiper-slide-prev {
      pointer-events: auto;
      visibility: visible;
    }

    .swiper-cube-shadow {
      position: absolute;
      left: 0;
      bottom: 0px;
      width: 100%;
      height: 100%;
      opacity: 0.6;
      z-index: 0;

      &:before {
        content: '';
        background: #000;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        -webkit-filter: blur(50px);
        filter: blur(50px);
      }
    }
  }
  //:deep(.swiper-cube) {
  //  .swiper-slide-next + .swiper-slide {
  //    pointer-events: auto;
  //    visibility: visible;
  //  }
  //}
  /* Cube slide shadows start */
  :deep(.swiper-cube) {
    .swiper-slide-shadow-cube.swiper-slide-shadow-top,
    .swiper-slide-shadow-cube.swiper-slide-shadow-bottom,
    .swiper-slide-shadow-cube.swiper-slide-shadow-left,
    .swiper-slide-shadow-cube.swiper-slide-shadow-right {
      z-index: 0;
      backface-visibility: hidden;
    }
  }
  /* Cube slide shadows end */
}
.def-swiper-progress {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  background-color: #e51544;
  height: 10px;
  z-index: 100;
  width: 0%;
}
.def-swiper-progress-active {
  width: 100%;
  transition: v-bind(progressSpeed) linear width;
}
</style>
